import React from 'react';

export const QuickActionCardContext = React.createContext({
  agent: {},
});
